import React from 'react';
import { FadeIn } from './FadeIn';
import { Leaf } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-24 px-6 bg-cream-light relative overflow-hidden" data-id="element-89">
      {/* Subtle decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full opacity-5 pointer-events-none flex items-center justify-center" data-id="element-90">
        <Leaf className="w-96 h-96 text-sage" strokeWidth={0.5} data-id="element-91" />
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-92">
        <FadeIn data-id="element-93">
          <p className="text-xl sm:text-2xl md:text-3xl leading-relaxed text-brown font-serif" data-id="element-94">
            Cada mañana te despiertas con esa rigidez en las rodillas, ese dolor
            que te impide moverte con libertad. Has probado muchas cosas, pero
            nada parece funcionar a largo plazo.
            <br data-id="element-95" />
            <br data-id="element-96" />
            <span className="text-terracotta font-medium italic" data-id="element-97">
              ¿Y si la solución estuviera en un enfoque integral, natural y
              diario?
            </span>
          </p>
        </FadeIn>
      </div>
    </section>;
}